import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Modal from './ErrorModal';
import '../styles/Login&RegisterPage.css';
import back from "../assets/icons/back-arrow.png"
import logo from '../moodmealslogo.png';

const LoginPage=({setIsLoggedIn})=>{
    
    const [logUser,setLogUser]=useState({
        emailPhone:'',
        password:''
    });

    const [message,setMessage]=useState("");
    const [isLoading,setIsLoading]=useState(true);
    const [showModal,setShowModal]=useState(false);
    const [loginSuccess, setLoginSuccess]=useState(false);
    const navigate = useNavigate();

    useEffect(()=>{
        setTimeout(()=>{
          setIsLoading(false);
        },2000);
    },[]);

    const handleSubmit=(e)=>{
        e.preventDefault();
        axios.post(`/api/users/login`,logUser,{withCredentials: true})
        .then(res=>{
            setLogUser({
                emailPhone:'', 
                password:''
            });
            setIsLoggedIn(true);
            setMessage("Login successful!");
            setShowModal(true);
            setLoginSuccess(true);
        })
        .catch(err=>{
            console.log("Error finding user:",err);
            setMessage("Login failed. Please try again.");
            setShowModal(true);
        });
    };
    
    const closeModal=()=>{
        setShowModal(false);
        if(loginSuccess){
            setIsLoading(true);
            setTimeout(()=>{
                setIsLoading(false);
                navigate('/');
            }, 2000);
        }
    };

    return(
        <>
            {isLoading?(
                <div className="loadingContainer">
                    <img src={logo} alt="Loading..." className="moodmeals-loading-logo"/>
                </div>
            ):(
            <>
                <div className="login-bg-wrapper">
                    <div className="login-flex"> 
                        <header className="login-header">
                            <div className="login-back">
                                <Link to="/"><img src={back} className="login-back-btn" alt="Back"/> Back</Link>
                            </div>
                            <div className="login-moodmeals-logo">
                                <img src={logo} alt="logo"/>
                            </div>
                        </header>
                        <div className="login-wrapper">
                            <div className="login">
                                <h2>Login</h2>
                                <form method="post" onSubmit={handleSubmit}>
                                    <div className="login-inputbox">
                                        <input type="text" value={logUser.emailPhone} onChange={(e)=>setLogUser({...logUser, emailPhone: e.target.value})} id="loginemailorphone" name="loginemailorphone"  minLength={10} maxLength={35} required="required"/>
                                        <span>Email or Phone</span>
                                        <i></i>
                                        <ii className='bx bxs-envelope' ></ii>
                                    </div>
                                    <div className="login-inputbox">
                                        <input type="password" value={logUser.password} onChange={(e)=>setLogUser({...logUser, password: e.target.value})} id="loginpw" name="loginpw" minLength={6} maxLength={20} required="required"/>
                                        <span>Password</span>
                                        <i></i>
                                        <ii className='bx bxs-lock-alt'></ii>
                                    </div>
                                    <div className="login-links">
                                        <a href="/">Forgot Password</a>
                                        <div>
                                            <span>Don't have an account?</span>
                                            <Link to="/register" id="registerbtn2" className="registerbtn2">Register</Link>
                                        </div>
                                    </div>
                                    <input id="LoginMo" type="submit" value="Login"/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="login-bg-wrapper2"></div>
                {showModal&&<Modal message={message} onClose={closeModal}/>}
            </>
            )}
        </>
    )
}

export default LoginPage;